// Collapsed onboarding state — a slim resume bar.
import { Button } from "../../../../../components/UI";
import { SECONDARY } from "../../../../../builders/buttonDesign.types";

import { Icon } from "./glyphs";
import { MinimizedBarStyles } from "./onboarding-minimized-bar.styles";

const OnboardingMinimizedBar = ({ status, onExpand }) => {
  const { requiredDone, requiredTotal } = status;
  const pct = requiredTotal ? (requiredDone / requiredTotal) * 100 : 0;

  return (
    <MinimizedBarStyles onClick={onExpand}>
      <span className="ob-min-badge">{Icon.sparkle(17)}</span>
      <div className="ob-min-main">
        <div className="ob-min-title">Finish setting up your shop</div>
        <div className="ob-min-progress">
          <div className="ob-min-track">
            <div className="ob-min-fill" style={{ width: `${pct}%` }} />
          </div>
          <span className="ob-min-count">
            {requiredDone} of {requiredTotal} done
          </span>
        </div>
      </div>
      <Button
        buttonDesignType={SECONDARY}
        onClick={onExpand}
        style={{ fontWeight: 600, whiteSpace: "nowrap" }}
      >
        Resume setup
      </Button>
      <span className="ob-min-chevron">{Icon.chevronDown(16)}</span>
    </MinimizedBarStyles>
  );
};

export default OnboardingMinimizedBar;
